import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=92c54434&"
import script from "./shipping.vue?vue&type=script&lang=ts&"
export * from "./shipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports